import React from "react";
import PreviewRequestPosDetailsBox from "../../../fragments/preview-fragment/PreviewFragment";
import { RavenGetValue, RavenNumberFormat } from "@ravenpay/raven-bank-ui";
import { formatTypeFunction } from "../../../helper";
import roundBankbox from "../../../assets/round bankbox.png";

interface MyComponentProps {
  details?: any;
}

const RequestVirtualTerminalPreview = ({ details }: MyComponentProps) => {
  const defaultList = [
    {
      label: "Terminal Type",
      value: formatTypeFunction(details?.type),
      key: "",
    },
    {
      label: "Terminal Label",
      value: "",
      key: "terminalLabel",
    },
    { label: "Quantity", value: "1", key: "quantity" },
    {
      label: "Account Number",
      value: "",
      key: "accountNo",
    },
    {
      label: "Purpose",
      value: "",
      key: "purpose?.value",
    },
    { label: "State", value: "", key: "state?.value" },
    { label: "City", value: "", key: "city?.value" },
    { label: "Address", value: "", key: "streetAddress" },
  ];

  return (
    <>
      <PreviewRequestPosDetailsBox
        amount={
          RavenNumberFormat(details?.quantity * details?.pricePerOne) as any
        }
        logoImg={roundBankbox}
        manualCompType
        manualList={RavenGetValue(defaultList, details)}
        details={details}
      />
    </>
  );
};

export default RequestVirtualTerminalPreview;
